module.exports = __webpack_public_path__ + "static/media/echo2.80bdeadd.png";